export default {
  ADMIN: 'Gatekeeper_Admin',
  PRODUSER: 'Gatekeeper_ReadOnly',
  VIEW: 'Gatekeeper_Produsers',
};
